(() => {
  const config = JSON.parse(document.getElementById('wb-minimum-order-config').textContent);
  const minimum = 1000;
  const approved = new WeakSet();
  let busy = false;
  async function readCart() {
    const response = await fetch(config.cartUrl + '.js', {cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }
  function show(cart) {
    const missing = Math.max(0, minimum - cart.total_price);
    const message = missing ? config.remaining.replace('{amount}', (missing / 100).toFixed(2)) : '';
    document.querySelectorAll('[data-wb-minimum-remaining]').forEach(el => { el.textContent = message ? ' ' + message : ''; });
    return missing === 0;
  }
  async function refresh() { try { show(await readCart()); } catch (_) {} }
  async function gate(event, form, button, link) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    try {
      const cart = await readCart();
      if (!show(cart)) {
        const note = [...document.querySelectorAll('[data-wb-minimum-note]')].find(el => el.getClientRects().length);
        if (note) { note.focus(); note.scrollIntoView({block:'nearest',behavior:'smooth'}); }
        else alert(config.remaining.replace('{amount}', ((minimum - cart.total_price) / 100).toFixed(2)));
        return;
      }
      if (form) {
        approved.add(form);
        try { button ? form.requestSubmit(button) : form.requestSubmit(); }
        finally { approved.delete(form); }
      } else if (link) { window.location.assign(link.href); }
    } catch (_) { alert(config.error); }
    finally { busy = false; }
  }
  document.addEventListener('click', event => {
    const el = event.target.closest('button[name="checkout"],input[name="checkout"],a[href]');
    if (!el) return;
    if (el.name === 'checkout' && el.form) {
      if (!approved.has(el.form)) gate(event, el.form, el, null);
      return;
    }
    if (el.tagName === 'A') {
      const url = new URL(el.href, location.href);
      if (url.origin === location.origin && /(^|\/)checkouts?(\/|$)/.test(url.pathname)) gate(event, null, null, el);
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (approved.has(form)) return;
    const button = event.submitter;
    if (button?.name === 'checkout' || /(^|\/)checkout(\/|$)/.test(new URL(form.action,location.href).pathname))
      gate(event, form, button, null);
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => { refresh(); });
  }
  window.addEventListener('pageshow', refresh);
  refresh();
})();